import module from 'app/module.js'
import template from './template.html'
import './style.scss'

class AppTableComponent {
  constructor ($element) {
    this.$element = $element
    this.data = null
    this.columns = null
  }

  $onInit () {
    const box = this.$element[0].getBoundingClientRect()

    this.$element.css('max-height', `calc(100vh - ${box.y}px)`)
  }
}

module.component('appTable', {
  controller: AppTableComponent,
  template,
  bindings: {
    data: '<',
  },
  transclude: {
    columns: 'appTableColumn',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/table/component.js